/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { switchOnMock } from '@/data/utils/switchOnMock';

export const CATALOG_ID = switchOnMock({ value: '11002', mockValue: '11501' });
